import { Controller } from "@hotwired/stimulus"

// Ordered picker for a deputy approval chain ("Stellvertretungsfreigabe").
//
// Each row is one chain member; the row order IS the rank, and array params are
// submitted in DOM order, so no hidden position bookkeeping is needed. One
// single-value select per row on purpose: a single SlimSelect multi-select does
// not preserve the order the entries were picked in, which is the whole point here.
export default class extends Controller {
  static targets = ["rows", "row", "rowTemplate"]

  connect() {
    this.renumber()
  }

  addRow(event) {
    event.preventDefault()

    const markup = this.rowTemplateTarget.innerHTML.replace(
      /__INDEX__/g,
      String(this.rowTargets.length),
    )
    this.rowsTarget.insertAdjacentHTML("beforeend", markup)
    this.renumber()
  }

  removeRow(event) {
    event.preventDefault()

    const row = event.target.closest("[data-deputy-chain-target='row']")
    if (row) row.remove()
    this.renumber()
  }

  // Rank badges are positional, so they have to be rewritten after every add/remove.
  renumber() {
    this.rowTargets.forEach((row, index) => {
      const badge = row.querySelector("[data-deputy-chain-position]")
      if (badge) badge.textContent = String(index + 1)
    })
  }
}
